import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-send-report-email',
  templateUrl: './send-report-email.component.html',
  styleUrls: ['./send-report-email.component.scss']
})
export class SendReportEmailComponent implements OnInit {
  filteredAllUserArray: Observable<any[]>;
  AllUserCtrl: FormControl;
  userfullName:any;
  userEmail:any;
  constructor(private dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  private dialogRef: MatDialogRef<SendReportEmailComponent>,private authService:AuthService,private opdvisitService:OpdVisitService) { }

  ngOnInit(): void {
    this.userfullName=null;
    this.userEmail=null;
    this.AllUserControll();
  }
  closesendemailRequestModal(){
   this.dialogRef.close();
  }
  AllUserControll() {
  
    this.AllUserCtrl = new FormControl();
    const checkcount = this.authService.users.filter(item => item.isActive == true);
    
    this.filteredAllUserArray = this.AllUserCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => checkcount.slice())
      );
  
  }
  getuser(e: any) {
    var val = e.option.value;
    this.userfullName = val.userName;
    this.userEmail=val.email;
  }
  base64ToBlob(base64: string,filename:any, contentType:any): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], filename, { type: contentType });
  }
  sendMail(){
    if(this.data.base64data && this.data.fileName && this.data.fileFormat){
     if( this.userEmail != "" && this.userEmail != null && this.userEmail != undefined){
        const blob = this.base64ToBlob(this.data.base64data,this.data.fileName,this.data.fileFormat);
        this.sendreportMail(blob);
       }else{
         this.authService.openSnackBar("Please update the email address in user master.", "OK");
       }
    }else{
      this.authService.openSnackBar("File not found.", "OK");
    }
  }
  sendreportMail(file:any){
    //Send Email to Patient
    var filedata = file;
    var emails =this.userEmail 
    const formData = new FormData();
    formData.append("file", filedata);
    formData.append("EmailType", "MIS");
    formData.append(
      "ToEmail",emails
    );
    this.opdvisitService.sendEmailtoPatient(formData);
    this.closesendemailRequestModal();
  
  }
}
